<div #layerElement class="multiple" [style]="styles">
  <ng-container *ngFor="let marker of markers; let i = index">
    <ca-player-timeline-category-marker
      [cls]="marker.class"
      [markerGroup]="marker"
      (markerClick)="onCategoryMarkerClick($event)"></ca-player-timeline-category-marker>
  </ng-container>
</div>
